import { set } from 'cerebral/operators'

export default [set('state:client.currentPage', 'forgotPassword')]



// WEBPACK FOOTER //
// ./src/modules/login/chains/forgotPassword.js